import React from 'react';
import PropTypes from 'prop-types';
import get from 'lodash/get';
import './show-applied-coupon.m.css';

const ShowAppliedCoupon = ({ appliedCoupon, resetCouponState }) => (
  <div styleName="wrapper">
    <div styleName="applied">
      <div data-testid="coupon-code">
        {get(appliedCoupon, ['discount_details', 'code'], '')} applied
      </div>
      <button styleName="clearBtn" data-testid="cross" onClick={resetCouponState} />
    </div>
  </div>
);

ShowAppliedCoupon.propTypes = {
  appliedCoupon: PropTypes.shape({
    discount_details: PropTypes.shape({
      title: PropTypes.string
    })
  }).isRequired,
  resetCouponState: PropTypes.func.isRequired
};

export default ShowAppliedCoupon;
